import React, { useState, useEffect } from "react";
import axios from "axios";
import { DataGrid, GridToolbar } from '@mui/x-data-grid';
import { Link, useParams } from 'react-router-dom';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

import {baseUrl, baseimgUrl, userLocation, ipAddress, userName, formatDateTime} from '../Univ.js'

function PatientDrugFlow(props){
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [mode, setMode] = useState({ mode: '' });
  const [rows, setRows] = useState([]);
  const [combinedData, setCombinedData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const handleStartDateChange = (date) => {
  const localDate = new Date(date.getTime() - date.getTimezoneOffset() * 60000);
  setStartDate(localDate);
};
 const handleEndDateChange = (date) => {
  const localDate = new Date(date.getTime() - date.getTimezoneOffset() * 60000);
  setEndDate(localDate);
};
  const handleMode = (event) => {
      setMode({
        ...mode,
        mode: event.target.value
      });
    };


  useEffect(() => {
      fetchData();
  }, [startDate, endDate, mode]);


  function fetchData() {
  setIsLoading(true);
  const startDateString = startDate ? startDate.toISOString().substring(0, 10) : '';
  const endDateString = endDate ? endDate.toISOString().substring(0, 10) : '';
  const url = `${baseUrl}all-pharm-sale/?start_date=${startDateString}&end_date=${endDateString}&mode=${mode.mode}&status=1`;
  axios.get(url)
    .then(response => {
      const filteredData = response.data.filter(item => item.mode !== 'Indent');
      setCombinedData(filteredData);
      setRows(filteredData);
      setIsLoading(false);
    })
    .catch(error => {
      console.log(error);
      setIsLoading(false);
    });
  }



  const columns = [
    { field: 'add_date_date', headerName: 'Date', width: 100 },
    { field: 'pat__pat_id', headerName: 'Pat ID', width: 150},
    { field: 'patient', headerName: 'Patient', width: 200 },

    { field: 'sale_type', headerName: 'Sale Type', width: 80 },
    { field: 'mode', headerName: 'Mode', width: 60 },
    {
      field: 'invoice',
      headerName: 'Invoice No',
      renderCell: (params) => {
        let invoiceLink = '';
        if (params.row.sale_type === 'IndentBill') {
          invoiceLink = `/pharm-invoice-indent/${params.row.sale_id}`;
        } else {
          invoiceLink = `/pharm-invoice-other/${params.row.sale_id}`;
        }
        return (
          <Link to={invoiceLink} target="_blank">
            {params.row.sale_id}
          </Link>
        );
      },
      width: 110
    },

    { field: 'total', headerName: 'Invoiced', width: 80 },
    { field: 'paid', headerName: 'Paid', width: 80 },
    { field: 'balance', headerName: 'Balance', width: 80 },
    { field: 'addedby', headerName: 'Cashier', width: 80 },
  ];

  const getTotal = (rows, field) => {
  return rows.reduce((totals, row) => {
    const value = parseFloat(row[field]);
    if (!isNaN(value)) {
      return totals + value;
    }
    return totals;
  }, 0);
};

const Footer = ({ rows }) => {
  const totalInvoicedAmount = getTotal(rows, 'total');
  const totalPaidAmount = getTotal(rows, 'paid');
  const totalBalance = getTotal(rows, 'balance');

  return (
    <div style={{ display: 'flex', justifyContent: 'space-evenly', padding: '8px' }}>
      <div>Total</div>
      <div>{totalInvoicedAmount?.toFixed(2)}</div>
      <div>{!isNaN(totalPaidAmount) ? totalPaidAmount.toFixed(2) : 'N/A'}</div>
      <div>{!isNaN(totalBalance) ? totalBalance.toFixed(2) : 'N/A'}</div>
    </div>
  );
};
  const today = new Date();

  return (
    <section className="container mt-4">
    <h3 className="text-center" style={{color: 'white', backgroundColor: '#0dcaf0'}}><i className="fa-solid fa-calendar-days"
        aria-hidden="true" style={{color: 'red'}}></i> Patient Flow Report </h3>
      <div className="row">
        <div className="col-md-3">
            <label className="control-label">Select Date</label>
            <DatePicker
                selected={startDate}
                onChange={handleStartDateChange}
                selectsStart
                startDate={startDate}
                endDate={endDate}
                placeholderText={'Please select From date'}
                dateFormat="dd/MM/yyyy"
                showMonthDropdown
                showYearDropdown
            />
            <DatePicker
                selected={endDate}
                onChange={handleEndDateChange}
                selectsEnd
                startDate={startDate}
                endDate={endDate}
                minDate={startDate}
                maxDate={today}
                placeholderText={'Please select To date'}
                dateFormat="dd/MM/yyyy"
                showMonthDropdown
                showYearDropdown
            />
            </div>

            <div className="col-md-3">
            <div className="mb-4 mt-4 form-control">
              <label htmlFor="mode" className="form-label">Search by Sales Mode</label>
              <select name="mode" id="mode" value={mode.mode} className="form-control"
                onChange={(event) => handleMode(event)}>
                <option value="">Select Sales Mode</option>
                <option value="cash">Cash</option>
                <option value="card">Card</option>
                <option value="creditpay">Credit Payment</option>
                <option value="advance">Advance</option>
                <option value="UPI">UPI</option>
              </select>
            </div>
            </div>
      </div>

  {!isLoading && combinedData.length > 0 ? (
        <div style={{ height: "100%", width: "100%" }}>
        <h3 className="text-center" style={{color: 'white', backgroundColor: '#0dcaf0'}}><i className="fa-solid fa-calendar-days"
        aria-hidden="true" style={{color: 'red'}}></i> View Patient wise sales</h3>
          <DataGrid className="mt-4"
            sx={{
              boxShadow: 4,
              border: 4,
              borderColor: 'primary.light',
              '& .MuiDataGrid-cell:hover': {
                color: 'primary.main',
              },
            }}
            rows={rows}
            columns={columns}
            pageSize={10}
            slots={{
              toolbar: GridToolbar,
            }}
            autoHeight
          />
          <table className="mt-4" style={{ width: '100%', borderCollapse: 'collapse' }}>
            <tfoot>
              <Footer rows={rows} />
            </tfoot>
          </table>
        </div>
      ) : (
        <></>
      )}
    </section>
  )
}

export default PatientDrugFlow;
